export const SET_BG = "SET_BG";
export const SKETCH_EXPLORED = "SKETCH_EXPLORED";
export const PRELOADED = "PRELOADED";
export const TITLE_LOADED = "TITLE_LOADED";